import { formatService } from '../common/format.service'
import { useStyles } from './map-key.style'
import { isSameScale } from './compare'

export const MapKey = ({ valueLabel, scale, mapKeyNote, valueType }) => {
  const classes = useStyles()
  const scaleDomain = scale.domain()

  let min, mid, max

  if (scaleDomain.length > 2) {
    // diverging scale
    [ min, mid, max ] = scaleDomain
  } else {
    // continuous scale
    [ min, max ] = scaleDomain
    mid = (min + max) / 2
  }

  // Infinity means that there is no data
  if (min === -Infinity || min === Infinity || max === Infinity || max === -Infinity) {
    return null
  }

  /**
   * Build out a list of colors along points on the scale to give more accurate granularity to the gradient
   * Process left and right separately to account for diverging scales which can have uneven sides
   */
  function buildColorList (scale, min, mid, max) {
    const granularity = 20

    const leftIncrement = (mid - min) / granularity
    const leftColors = []
    let curr = min
    while (curr < mid) {
      leftColors.push(scale(curr))
      curr += leftIncrement
    }

    const rightIncrement = (max - mid) / granularity
    const rightColors = []
    curr = max
    while (curr > mid) {
      rightColors.unshift(scale(curr))
      curr -= rightIncrement
    }

    return [...leftColors, ...rightColors].join(',')
  }

  return (
    <div className={classes.key}>
      <div className={classes.title}>{valueLabel}</div>
      <div>
        <div className={classes.labels}>
          <div className={classes.labelLeft}>{formatService.formatShortenedValue(min, valueType)}</div>
          <div className={classes.labelCenter}>{formatService.formatShortenedValue(mid, valueType)}</div>
          <div className={classes.labelRight}>{formatService.formatShortenedValue(max, valueType)}</div>
        </div>
        <div className={classes.scale} style={{
          background: `linear-gradient(0.25turn, ${buildColorList(scale, min, mid, max)})`
        }} />
        {mapKeyNote && mapKeyNote.trim().length > 0 &&
          <div className={classes.note}>({mapKeyNote})</div>
        }
      </div>
    </div>
  )
}

export const areMapKeysEqual = (prev, next) => {
  return isSameScale(prev.scale, next.scale) &&
    prev.valueLabel === next.valueLabel &&
    prev.valueType === next.valueType &&
    prev.mapKeyNote === next.mapKeyNote &&
    prev.width === next.width &&
    prev.height === next.height
}
